"use strict";
Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x4, _x5, _x6) { var _again = true; _function: while (_again) { var object = _x4, property = _x5, receiver = _x6; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x4 = parent; _x5 = property; _x6 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _QueryBuilder2 = require('./QueryBuilder');

var _QueryBuilder3 = _interopRequireDefault(_QueryBuilder2);

/**
* Browser performs queries and construct proper objects.
* @extends {QueryBuilder}
*/

var Browser = (function (_QueryBuilder) {
    _inherits(Browser, _QueryBuilder);

    /**
    * Builds the object based on given parameters.
    * @param {object=} params
    * @constructor
    */

    function Browser() {
        var params = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

        _classCallCheck(this, Browser);

        _get(Object.getPrototypeOf(Browser.prototype), 'constructor', this).call(this, params);
        this.factory = params.factory || null;
    }

    /**
    * Performs a request for a given url using APICLient
    * @param {string} url The url to request.
    * @return {Promise}
    */

    _createClass(Browser, [{
        key: '_query',
        value: function _query(url) {
            var method = arguments.length <= 1 || arguments[1] === undefined ? 'GET' : arguments[1];
            var payload = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

            return this._getClient().request(url, method, payload);
        }

        /**
        * Fetches all results for the filter configuration and builds objects by factory.
        * @return {Promise}
        */
    }, {
        key: 'all',
        value: function all() {
            var _this = this;

            var url = undefined;
            switch (this.query_type) {
                default:
                case 'search':
                    url = this._getSearchUrl();
                    break;
                case 'artists-top-tracks':
                    url = this._getArtistsTopTracksUrl();
                    break;
                case 'artists-albums':
                    url = this._getArtistsAlbumsUrl();
                    break;
                case 'artist-artists':
                    url = this._getRelatedArtistsUrl();
                    break;
                case 'entity':
                    url = this._getEntityUrl();
                    break;
            }

            var promise = this._query(url);
            return promise.then(function (response) {
                var collection = [];
                var itemsData = undefined;
                eval('itemsData = ' + _this.selector);
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = itemsData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var item = _step.value;

                        collection.push(new _this.factory(item));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator['return']) {
                            _iterator['return']();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                return collection;
            }, function (reject) {
                console.log(reject);
                return reject;
            });
        }

        /**
        * Fetches results for a search url using QueryBuilder.all and returns the first element.
        * @return {Promise}
        */
    }, {
        key: 'first',
        value: function first() {
            this.limit = 1;
            this.offset = 0;
            return this.all().then(function (val) {
                return val.pop();
            });
        }

        /**
        * Fetches elements by id with entity url.
        * @return {Promise}
        * @see https://developer.spotify.com/web-api/get-album/
        * @see https://developer.spotify.com/web-api/get-artist/
        * @see https://developer.spotify.com/web-api/get-track/
        * @see https://developer.spotify.com/web-api/get-playlist/
        * @see https://developer.spotify.com/web-api/get-users-profile/
        */
    }, {
        key: 'get',
        value: function get() {
            var _this2 = this;

            var url = this._getEntityUrl();
            return this._query(url).then(function (response) {
                return new _this2.factory(response);
            });
        }

        /**
        * Provides developer help logging the status.
        * @override
        */
    }, {
        key: 'toString',
        value: function toString() {
            console.warn("You are trying to get objects but a final call was missing. Try adding all(), get() or first()");
        }
    }, {
        key: 'send',
        value: function send(payload) {
            var url = undefined,
                method = undefined;
            //@TODO Would be great if this settings could be pulled out from a WSDL
            switch (this.query_type) {
                default:
                case 'create-playlist':
                    url = this._getWritePlaylistUrl();
                    method = 'POST';
                    break;
                case 'change-playlist':
                    url = this._getWritePlaylistUrl();
                    method = 'PUT';
                    break;
                case 'add-playlist-tracks':
                    url = this._getWritePlaylistTracksUrl();
                    method = 'POST';
                    break;
                case 'remove-playlist-tracks':
                    url = this._getWritePlaylistTracksUrl();
                    method = 'DELETE';
                    break;
                case 'reorder-playlist-tracks':
                    url = this._getWritePlaylistTracksUrl();
                    method = 'PUT';
                    break;
            }
            return this._query(url, method, payload);
        }
    }]);

    return Browser;
})(_QueryBuilder3['default']);

exports['default'] = Browser;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/spotify-client/lib/classes/Browser.js
 ** module id = 67
 ** module chunks = 0
 **/